import { STATES } from 'common/domain/states';
import { LOANS } from '../../common/domain/constants.loans.js';
import { MODALS, EVENTS } from 'common/domain/constants';
import LoansModalitiesAssembler from 'loans.module/common/assemblers/loans.modalities.assembler';
import isReloaded from 'common/utils/isReloaded';
import MenuFamilyNeedALoanFormatter from '../needALoan/menuFamilyNeedALoan/menuFamilyNeedALoan.formatter.js';

const STEPS = {
  SIMULATION: 'simulation',
  FORM: 'form',
  RESUME: 'resume',
};

class LoansSignUpController {
  constructor(
    $stateParams,
    $log,
    $state,
    $window,
    $rootScope,

    loansStaticService,
    LoansUserDataService,
    LoansOperationsService,
    loansSignUpService,
    GoBackDataService,
    mainMenuMobileBehaviourService,
    LoansNeedALoanService,
    loadingMobileService,
    metricsService,
    myLoansService
  ) {
    'ngInject';
    this.stateParams = $stateParams;
    this.log = $log;
    this.state = $state;
    this.window = $window;
    this.rootScope = $rootScope;

    this.loansStaticService = loansStaticService;
    this.loansUserDataService = LoansUserDataService;
    this.loansOperationsService = LoansOperationsService;
    this.loansSignUpService = loansSignUpService;
    this.goBackDataService = GoBackDataService;
    this.mainMenuMobileBehaviourService = mainMenuMobileBehaviourService;
    this.loansNeedALoanService = LoansNeedALoanService;
    this.loadingMobileService = loadingMobileService;
    this.metricsService = metricsService;
    this.simulationWitness = false;
    this.isMobileApp = $window.innerWidth < 1024;
    this.myLoansService = myLoansService;
    this.snapshotSeeConditions = this.goBackDataService.getDataSeeConditions();
    this.snapshotSignUp = this.goBackDataService.getDataBackToSignUp();
    this.from = STATES.LOANS.LOANS_CATALOG;
    this.initialCharges = 0;
    this.data = null;
    this.preventEnterWithoutSnapshot();
    this.loading = false;
    if (this.isDataOnSnapshot()) {
      this.initFromSnapshot();
    } else {
      this.init();
    }

  }

  $onInit() {
    if (this.serviceClosed) {
      this.state.go(STATES.LOANS.LOANS_CATALOG);
    }

    if (this.isMobileApp) {
      this._checkFromToSnapshot();
    }

    this.setLoanPurposes();
    this.loadInitialCharges();
    this.getCreditworthiness();
  }

  isDataOnSnapshot() {
    return (
      (this.stateParams.snapshot ||
        this.snapshotSeeConditions ||
        this.snapshotSignUp) &&
      !this.stateParams.hardReset
    );
  }

  _checkFromToSnapshot() {
    if (this.form === STATES.LOANS.CADASTRAL_REFERENCE) {
      this.state.go(STATES.LOANS.LOANS_CATALOG);
    }
  }

  getClasses() {
    return {
      responsiveMobile: this.isMobileApp,
      'with-floating-action-buttons': this.isMobileApp,
    };
  }

  preventEnterWithoutSnapshot() {
    if (!isReloaded()) {
      return;
    }

    if (
      this.stateParams.from === STATES.LOANS.NEED_A_LOAN &&
      !this.stateParams.snapshot
    ) {
      this.state.go(this.stateParams.from);
    }
  }

  initFromSnapshot() {
    this.loading = true;
    const snapshot =
      this.stateParams.snapshot ||
      this.snapshotSignUp ||
      this.snapshotSeeConditions;
    this.loanSimulationRequest = snapshot.loanSimulation;
    this.step = snapshot.step;
    this.loan = snapshot.loan;
    this.simulation = snapshot.simulation;
    this.backSimulation = snapshot.backSimulation;
    this.loanPurposes = snapshot.loanPurposes;
    this.housingChange = snapshot.housingChange;
    this.housingLoan = snapshot.housingLoan;
    this.isVariousCredit = snapshot.isVariousCredit;
    this.dataToGoBack = snapshot.dataToGoBack;

    this.from = snapshot.from || this.stateParams.from;
    this.originalFrom = this.stateParams.originalFrom;

    if (this.isMobileApp) {
      this.createLoanError = snapshot.createLoanError;
      this.createLoanSuccess = snapshot.createLoanSuccess;
      this.errorMessage = snapshot.errorMessage;
      this.loanResponseId = snapshot.loanResponseId;
      this.setTitleMenu(this.from);

      if (this.isForm()) {
        this.goToFormOnBack();
      }
    }
    this.loading = false;
  }

  init() {
    this.loading = true;

    this.step = STEPS.SIMULATION;
    this.loanId = this.stateParams.loanId;
    this.loan = this.loansStaticService.get(this.loanId);
    this.housingLoan =
      this.loan.id === LOANS.ID.SOCIAL_HOUSING_LOAN ||
      this.loan.id === LOANS.ID.AGREEMENT_HOUSING_LOAN;
    this.isVariousCredit = this.loan.id === LOANS.ID.VARIOUS_CREDIT;
    this.loading = false;
  }

  get modal() {
    const $modal = $(MODALS.SIGN_UP);
    return $modal;
  }

  getCreditworthiness() {
    // TODO: [Manu] esta peticion de creditworthiness es solo para comprobar housingWitness, como no es un flag que cambie así como así durante el proceso de contratación, estaría bien arrastrarlo desde el primer paso de sign-up / need a loan
    this.loading = true;
    this.loadingMobileService.show();
    this.loansOperationsService
      .getCreditworthiness(this.loansUserDataService._employee.userId)
      .then(
        (creditworthiness) => {
          this.creditworthiness = creditworthiness;
          this.housingChange = creditworthiness.housingWitness;
          this.simulationWitness = creditworthiness.simulationWitness;
          const creditworthinessPayload = {
            raw: creditworthiness,
            simulatedLimits: [
              creditworthiness.socialHousingLoanSimulated,
              creditworthiness.socialHousingLoanFixedSimulated,
              creditworthiness.agreementHousingLoanSimulated,
              creditworthiness.agreementHousingLoanFixedSimulated
            ]
          };
          this.data = new MenuFamilyNeedALoanFormatter(creditworthinessPayload).format();
          this.loaded = true;
          this.rootScope.$applyAsync();
        },
        (error) => {
          this.log.error(
            'LoansSignUpController constructor getCreditworthiness()',
            error
          );
          // TODO: [Manu] eliminado ya que probablemente sea motivo de error en la APP. Ver si en la Web es necesario o con el errorInterceptor es suficiente
          // this.state.go(STATES.ERROR);
        }
      )
      .finally(() => {
        this.loadingMobileService.hide();
        this.loading = false;
      });
  }

  setTitleMenu(from) {
    if (from === STATES.LOANS.LOANS_CATALOG) {
      this.rootScope.$broadcast(EVENTS.CHANGE_TITLE, {
        title: 'LOANS.LOANS_CATALOG.TITLE',
      });
    }

    if (from === STATES.LOANS.NEED_A_LOAN) {
      this.rootScope.$broadcast(EVENTS.CHANGE_TITLE, {
        title: 'LOANS.NEED_A_LOAN.TITLE',
      });
    }
  }

  setLoanPurposes() {
    const modalities = this.loansUserDataService.getModalities();
    const loansModalitiesAssembler = new LoansModalitiesAssembler(modalities);
    const allPurposes = loansModalitiesAssembler.assemble();
    this.loanPurposes = allPurposes[this.loan.id];
  }

  setSimulation($event) {
    this.simulation = $event;
    this.log.info('LOCAL Simulation is:', this.simulation);

    const userId = this.loansUserDataService._employee.userId;
    const loan = this.loan;
    const simulationEndpoint = this.buildEndpointSimulation(
      this.simulation,
      loan
    );
    const codeOptionIsHousingPurpose =
      this.codeOptionSelected === LOANS.ID_HR.SOCIAL_HOUSING_LOAN;

    this.loadingMobileService.show();

    this.loansSignUpService
      .createSimulation(userId, simulationEndpoint)
      .then(
        (response) => {
          this.loanSimulationRequest = this.filterSimulation(
            response,
            codeOptionIsHousingPurpose
          );
          this.loanSimulationRequest.simulation = this.simulation;
          this.setBackSimulation(response.data.simulations);
          this.log.info('BACK Simulation is:', this.backSimulation);
          this.scrollToTop();

          if (this._isStatusSimulationKO()) {
            this.errorMessage = this.backSimulation.status.message;
            this.errorBackSimulation = true;
            this.openModal();
            return;
          }

          if (this.isMobileApp) {
            this.goToFormOnBack();
          }

        },
        (response) => {
          this.errorMessage = response.data.message;
          this.errorBackSimulation = true;
          this.scrollToTop();
          this.openModal();
        }
      )
      .finally(() => {
        this.step = STEPS.RESUME;
        this.loadingMobileService.hide();
      });
  }

  scrollToTop() {
    this.window.scrollTo(0, 0);
  }

  _isStatusSimulationKO() {
    return this.backSimulation.status.code === LOANS.STATUS.KO;
  }

  buildEndpointSimulation({ loanPurpose, amountSimulation }, loan) {
    const endpointSimulation = {
      loanId: loan.idHr,
      loanPurposeId: loanPurpose.value,
      amount: amountSimulation.amount,
      wantInsurance: amountSimulation.wantInsurance,
      typeFixedVariable: amountSimulation.typeFixedVariable || '0',
      isSimulation: amountSimulation.isSimulation || false
    };

    if (amountSimulation.fixedFeeNumber) {
      endpointSimulation.deadline = parseInt(
        amountSimulation.fixedFeeNumber,
        10
      );
    }

    if (amountSimulation.monthlyFeeAmount) {
      endpointSimulation.monthlyAmount = amountSimulation.monthlyFeeAmount;
    }

    const isHousingPurpose =
      loanPurpose.value === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE ||
      this.codeOptionSelected === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
    if (isHousingPurpose && loan.idHr !== LOANS.ID_HR.VARIOUS_CREDIT 
        && loan.idHr !== LOANS.ID_HR.DIVERSAL_ATENTION) {
      endpointSimulation.acquisitionCost =
        amountSimulation.acquisitionCost != null
          ? amountSimulation.acquisitionCost
          : amountSimulation.diff;

      if (this.housingChange) {
        endpointSimulation.salePrice = amountSimulation.salePrice;
      }
    }

    return endpointSimulation;
  }

  setBackSimulation(simulations) {
    this.backSimulation = simulations[0];
    this.backSimulation.diff = this.simulation.amountSimulation.diff;
  }

  filterSimulation(simulation, isHousingPurpose) {
    return simulation.data.simulations.filter((loanSimulation) => {
      this.setInfo(loanSimulation);
      if (isHousingPurpose) {
        return loanSimulation.loanId !== LOANS.ID_HR.VARIOUS_CREDIT;
      }
      return true;
    });
  }

  setInfo(loanSimulation) {
    const loan = this.getLoan(loanSimulation.loanId);
    loanSimulation.title = this.loansStaticService.get(
      loanSimulation.loanId
    ).title;
    this.setTitleFixedVariable(loanSimulation);
    loanSimulation.id = loan.id;
  }

  getLoan(loanId) {
    return this.loansStaticService.get(loanId);
  }

  setTitleFixedVariable(loanSimulation) {
    const loanId = loanSimulation.loanId;
    if (
      loanId === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN ||
      loanId === LOANS.ID_HR.SOCIAL_HOUSING_LOAN
    ) {
      loanSimulation.title += (loanSimulation.typeFixedVariable === '1')
        ? '_FIXED'
        : '_VARIABLE';
    }
  }

  onCreateLoan($event) {
    const userId = this.loansUserDataService._employee.userId;
    const loan = this.sanitizeLoanOnCreate(
      $event.loan,
      this.simulation.amountSimulation
    );

    this.loadingMobileService.show();
    this.loansOperationsService
      .createLoan(userId, loan)
      .then(
        (response) => {
          this.createLoanSuccess = true;
          this.loanResponseId = response.data.loanId;

          this.log.info('loansSignUp', loan);
          this.metricsService.trackLoansSignup({ loanType: loan.idHr });

          this.setDataLoanOnServiceGoBack();
          this.scrollToTop();
        },
        (error) => {
          this.errorMessage = error.data.message;
          this.createLoanError = true;
          this.setDataLoanOnServiceGoBack();
          this.scrollToTop();
        }
      )
      .finally(() => {
        this.step = STEPS.RESUME;
        this.loadingMobileService.hide();
      });
  }

  setDataLoanOnServiceGoBack() {
    let dataBackToSignUp = {
      loan: this.loan,
      createLoanSuccess: this.createLoanSuccess,
      createLoanError: this.createLoanError,
      errorMessage: this.errorMessage,
      loanResponseId: this.loanResponseId,
      backSimulation: this.backSimulation,
      from: this.from,
    };
    this.goBackDataService.setDataBackToSignUp(dataBackToSignUp);
  }

  sanitizeLoanOnCreate(loan, fieldsSent) {
    delete loan.annualPercentageRate;
    delete loan.interestRate;
    delete loan.tae;

    if (!fieldsSent.fixedFeeNumber) {
      delete loan.deadline;
    }

    if (!fieldsSent.monthlyFeeAmount) {
      delete loan.monthlyAmount;
    }

    if (!this.housingLoan) {
      delete loan.acquisitionCost;
      delete loan.salePrice;
    } else if (!this.housingChange) {
      delete loan.salePrice;
    }

    return loan;
  }

  isSimulation() {
    return this.step === STEPS.SIMULATION;
  }

  isForm() {
    return this.step === STEPS.FORM;
  }

  isResume() {
    return this.step === STEPS.RESUME;
  }

  onCancelCreateLoan() {
    if (this.originalFrom) {
      return this.state.go(this.originalFrom);
    }

    if (this.from && this.from !== STATES.LOANS.NEED_A_LOAN) {
      this.step = STEPS.SIMULATION;
      this.mainMenuMobileBehaviourService.clean();
      return;
    }

    this.loansNeedALoanService.setDataSimulation(this.dataToGoBack);

    if (!this.from) {
      return this.state.go(STATES.LOANS.NEED_A_LOAN);
    }

    this.window.history.back();
  }

  openModal() {
    this.modal.modal('show');
  }

  goToInitForm() {
    this.step = STEPS.SIMULATION;
  }

  onOpenDetail() {
    const snapshot = this.getSnapshot();
    this.loansNeedALoanService.setDataSimulation(this.dataToGoBack);
    this.goBackDataService.setDataSeeConditions(snapshot);

    let originalFrom;

    if (this.from === STATES.LOANS.NEED_A_LOAN) {
      originalFrom = STATES.LOANS.NEED_A_LOAN;
    }

    this.state.go(STATES.LOANS.DETAIL, {
      loanId: this.loan.id,
      allowGoBack: true,
      panel: 'basic-characteristics',
      from: STATES.LOANS.SIGN_UP,
      originalFrom,
      snapshot: snapshot,
    });
  }

  getSnapshot() {
    return {
      step: this.step,
      loan: this.loan,
      simulation: this.simulation,
      backSimulation: this.backSimulation,
      loanPurposes: this.loanPurposes,
      housingChange: this.housingChange,
      housingLoan: this.housingLoan,
      isVariousCredit: this.isVariousCredit,
      dataToGoBack: this.dataToGoBack,
    };
  }

  goToFormOnBack() {
    this.mainMenuMobileBehaviourService.setCustomBehaviour(() => {
      this.onCancelCreateLoan();
    });
  }

  openDetail(loanSimulation) {
    let dataToDetail = {
      loanId: loanSimulation.id,
      allowGoBack: !this.isMobileApp,
      loanSimulationRequest: this.loanSimulationRequest,
      simulation: this.simulation,
      familySelected: this.familySelected,
      optionFamilySelected: this.optionFamilySelected,
      families: this.families,
      codeOptionSelected: this.codeOptionSelected,
      loan: this.loan
    };

    this.loansNeedALoanService.onOpenDetailCatalog(dataToDetail);
  }

  checkLoanSimulationRequest() {
    return this.loanSimulationRequest !== undefined;
  }

  checkSimulationIsOkey(loanSimulation) {
    if (loanSimulation === undefined) return;
    return loanSimulation.status.code === LOANS.STATUS.OK;
  }

  selectLoan(loanSimulation, isSignUp) {
    let response = this.loansNeedALoanService.onSelectLoan(
      {
        loanId: loanSimulation.id,
        loanSimulation: loanSimulation,
        creditworthiness: this.creditworthiness,
        simulation: this.simulation,
        dataToGoBack: this.snapshot,
      },
      isSignUp
    );

    this.backSimulation = loanSimulation;
    if (response !== undefined) {
      return this.presentCannotSignUpModal(response);
    }
    this.step = STEPS.FORM;
  }

  presentCannotSignUpModal(reason) {
    this.cannotSignUpError = reason;
    this.modal.modal('show');
  }

  isFiveOrNineMonth(loanId) {
    return loanId === LOANS.ID.FIVE_MONTH || loanId === LOANS.ID.NINE_MONTH;
  }

  isSocialAgreement(loanId) {
    return loanId === LOANS.ID.AGREEMENT_HOUSING_LOAN;
  }

  showIconInfoOnAmount() {
    return false;
  }

  showIconInfoOnInterests(loanId) {
    return !this.isFiveOrNineMonth(loanId);
  }

  showIconInfoOnDeadline() {
    return true;
  }

  showIconInfoOnInsurance(loanSimulation) {
    return loanSimulation.wantInsurance;
  }

  showLoanCV(loanId) {
    return loanId === LOANS.ID.VARIOUS_CREDIT;
  }

  showLoanDA(loanId) {
    return loanId === LOANS.ID.DIVERSAL_ATENTION;
  }

  showLoanVC(loanId) {
    return loanId === LOANS.ID.AGREEMENT_HOUSING_LOAN;
  }

  showLoanSV(loanId) {
    return loanId === LOANS.ID.SOCIAL_HOUSING_LOAN;
  }

  showLoan9S(loanId) {
    return loanId === LOANS.ID.NINE_MONTH;
  }

  showLoan5S(loanId) {
    return loanId === LOANS.ID.FIVE_MONTH;
  }

  modifyLoan() {
    if (this.isMobileApp) return this.state.go(STATES.LOANS.NEED_A_LOAN);
    this.onModifyLoan();
  }

  goMyLoans() {
    this.state.go(STATES.LOANS.MY_LOANS);
    this.modal.modal('hide');
  }

  showSalePrice(loanSimulation) {
    return (
      loanSimulation.loanPurposeId === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE &&
      (this.housingWitness === true || this.simulationWitness === true)
    );
  }

  loadInitialCharges() {
    const employeeId = this.loansUserDataService._employee.userId;
    this.myLoansService
      .getMyLoans(employeeId)
      .then(loansList => {
        const loan = loansList.find(l =>
          (l.modalityCode === 'SV' || l.modalityCode === 'CV')
          && l.amortizable === true
        );
        this.initialCharges = loan ? loan.amountPending : 0;

      })
      .catch(err => {
        this.log.error('Error fetching myLoans:', err);
      });
  }

  selectButtonShouldAppear() {
    return this.simulationWitness && (this.loan.idHr === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.loan.idHr === LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.loan.idHr === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN);
  }
}

export default LoansSignUpController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUp.controller.js